import { Buffer } from 'buffer';

window.Buffer = Buffer;
window.global = window;

// Secure and clean environment setup
// We no longer manually assign to process.env to ensure zero security risk.
// All code has been migrated to use import.meta.env[key] directly.
